import * as R from 'remeda';
import { ActionType } from 'typesafe-actions';

import * as realtimeActions from './actions';
import * as realtimeConstants from './constants';
import realtimeReducer from './reducer';
import * as realtimeSagas from './sagas';
import * as realtimeSelectors from './selectors';

export type RealtimeState = { selectedDay: Time.Day };

export type RealtimeAction = ActionType<typeof realtimeActions>;

const realtimeSagaActions = R.pick(realtimeActions, ['startSelectDay']);

export type RealtimeSagaAction = ActionType<typeof realtimeSagaActions>;

export {
  realtimeActions,
  realtimeConstants,
  realtimeReducer,
  realtimeSagas,
  realtimeSelectors,
};
